import "./Home.css";
import React from "react";
import { Typography, Button, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Box } from "@mui/system";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Box sx={{
                backgroundColor: 'secondary.main'
            }}>
                <Typography variant="h6" fontFamily={"Century"} align="left" color={'#f5b342'}>
                    Mi Manera is een uniek micro-restaurant in het Oud-Huys van Hotel Elisabeth te Mechelen, op amper 10 minuutjes lopen van de Mechelse Grote Markt. De eetzaal wasemt een unieke Spaanse sfeer uit en biedt plaats aan 20 tot maximaal 24 personen. Er heerst een ongedwongen, huiselijke, warme sfeer.
                    <br /><br />
                    Reserveren is zeker aangeraden.
                    <br /><br />
                    Parkeren doen klanten gratis in de ondergrondse parking van het hotel onder voorbehoud van beschikbaarheid. Meld je aan bij de receptie van het Hotel vanwaar je verder wordt begeleid.
                    <br /><br />
                    Bij mooi weer is je tafeltje buiten op het binnenterras gereserveerd, onder de olijfbomen.
                    <br /><br />
                    De keuken wordt wekelijks ter beschikking gesteld aan een gepassioneerde ‘amateur’kok of ‘super’chef, die ons telkens verrast met een vast menu: persoonlijk, creatief en uniek in zijn eigen culinaire stijl. Kom eens proeven en word ambassadeur van een van onze chefs. In een rotatie van 4 tot 6 weken komen ze terug!
                    <br /><br />
                    Alleen op donderdag , vrijdag en zaterdag
                </Typography>
                <Box width="100%" align="center"><div className="Marisa" /></Box>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'space-around',
                    alignItems: 'baseline',
                    p: 1,
                    m: 1,
                }}>
                    <Link href="http://maps.google.com/?q=hotel+elisabeth+mechelen" variant="h6" color={'#f5b342'} textAlign={"center"}>
                        Hotel Elisabeth
                    </Link>
                    <Typography variant="h6" color={'#f5b342'} textAlign={"center"}>
                        Geopend op donderdag, vrijdag en zaterdag
                    </Typography>
                    <Link href="mailto:contact@mi-manera.be" variant="h6" color={'#f5b342'} textAlign={"center"}>
                        contact@mi-manera.be
                    </Link>
                    <Link href="tel:0032478273572" variant="h6" color={'#f5b342'} textAlign={"center"}>
                        0032/478.27.35.72
                    </Link>
                </Box>
            </Box>
        );
    }
}
